



























import Vue from 'vue'
import { AccountBalanceMoneyElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'AccountBalanceMoneyEl',

  props: {
    templateItemData: {
      type: Object as () => AccountBalanceMoneyElInterface,
      required: true
    }
  }
})
